(function () {
  class GiwLogosSlider {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('.giw-logos__track');
      this.window = section.querySelector('.giw-logos__window');
      this.prevBtn = section.querySelector('.giw-logos__nav--prev');
      this.nextBtn = section.querySelector('.giw-logos__nav--next');

      if (!this.track || !this.prevBtn || !this.nextBtn) return;

      this.originals = Array.from(this.track.children);
      this.itemCount = this.originals.length;
      if (this.itemCount === 0) return;

      this.originals.forEach((item) => {
        this.track.appendChild(item.cloneNode(true));
      });
      this.originals.forEach((item) => {
        this.track.insertBefore(item.cloneNode(true), this.track.firstChild);
      });

      this.index = this.itemCount;
      this.itemWidth = 0;

      this.measure();
      this.applyTransform(false);

      this._onResize = () => {
        this.measure();
        this.applyTransform(false);
      };
      window.addEventListener('resize', this._onResize);

      this.prevBtn.addEventListener('click', () => this.go(-1));
      this.nextBtn.addEventListener('click', () => this.go(1));

      this.track.addEventListener('transitionend', (e) => {
        if (e.propertyName === 'transform') this.normalize();
      });
    }

    measure() {
      const first = this.track.children[0];
      if (!first) return;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      this.itemWidth = first.offsetWidth + gap;
    }

    applyTransform(animate) {
      this.track.style.transition = animate ? 'transform 0.4s ease' : 'none';
      this.track.style.transform = `translateX(${-this.index * this.itemWidth}px)`;
    }

    go(dir) {
      this.index += dir;
      this.applyTransform(true);
    }

    normalize() {
      if (this.index >= this.itemCount * 2) {
        this.index -= this.itemCount;
        this.applyTransform(false);
      } else if (this.index < this.itemCount) {
        this.index += this.itemCount;
        this.applyTransform(false);
      }
    }
  }

  function initAll(root) {
    const scope = root || document;
    scope.querySelectorAll('.giw-logos').forEach((section) => {
      if (section.dataset.giwLogosInit === '1') return;
      section.dataset.giwLogosInit = '1';
      new GiwLogosSlider(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
